import React, {FunctionComponent} from 'react';
import {concepts, User} from 'fearless-common';
import {Badge} from 'react-bootstrap';
import {StandardIcons} from "../index";
import {routes} from "../../../utils";
import {isDev, isInternal} from "../../../utils/env";
import isAdmin from "../../../utils/isAdmin";
import {adminRoutes} from "../../../utils/routes";

export interface MenuItem {
  label: string | React.JSX.Element;
  href: string;
  icon?: FunctionComponent;
  target?: '_blank',
  separatorTop?: boolean;
  className?: string;
  options?: MenuItem[];
}

const adminLinks = [
  { href: adminRoutes.insights, label: 'Insights' },
  { href: adminRoutes.institutes, label: concepts.Institutes },
  { href: adminRoutes.users, label: concepts.Users },
  { href: adminRoutes.groups, label: concepts.Groups },
  { href: adminRoutes.subscriptions, label: concepts.Subscriptions },
  { href: adminRoutes.notifications, label: 'Notifications' },
  { href: adminRoutes.products, label: 'Stripe products' },
  { href: adminRoutes.prices, label: 'Stripe prices' },
  { href: adminRoutes.subscriptionRules, label: concepts.SubscriptionRule },
  { href: adminRoutes.communicationMocks, label: 'Communication Mocks' },
  { href: adminRoutes.files, label: 'Files' },
  { href: adminRoutes.signUpCodes, label: concepts.SignUpCodes },
  { href: adminRoutes.loggedUiEvents, label: concepts.LoggedUIEvents },
];

/**
 * Generate the sidebar menu items after a user has logged-in.
 */
export default function sideBarMenuItems({ user }: {
  /** The logged-in user */
  user: User
}): MenuItem[] {
  // Dynamically build menu options
  const items: MenuItem[] = [
    {
      href: routes.photo51Cloud,
      icon: () => <StandardIcons.Photo51 width={25} />,
      label: `${concepts.Photo51} Cloud`,
      target: '_blank',
    }
  ];

  if (user?.subscription_per_product?.eln) {
    items.push({
      href: routes.elnCloud,
      icon: () => <StandardIcons.Eln width={25} />,
      label: <>Spark ELN</>,
      target: '_blank',
    });
  }

  if (isDev() || isInternal()) {
    items.push({
      href: routes.limsCloud,
      icon: StandardIcons.Lims,
      label: <>LIMS <Badge>internal only</Badge></>,
      target: '_blank',
    });
  }

  items.push({
    href: routes.download,
    icon: StandardIcons.Download,
    label: `Download ${concepts.Photo51}`,
  }, {
    separatorTop: true,
    href: routes.groups,
    icon: StandardIcons.Group,
    label: `My ${concepts.Groups}`,
  }, {
    icon: StandardIcons.Account,
    label: 'My Account',
    href: '#account',
    options: [
      { href: routes.security, label: concepts.Security, icon: StandardIcons.Security },
      { href: routes.personalInformation, label: concepts.PersonalInformation, icon: StandardIcons.PersonalInformation },
    ]
  }, {
    href: routes.subscriptions(),
    icon: StandardIcons.Subscriptions,
    label: concepts.Subscriptions,
  })
  if (isAdmin(user)) {
    items.push({
      separatorTop: true,
      icon: StandardIcons.AdminEnvironment,
      label: 'Admin',
      href: '#admin',
      options: adminLinks,
    });
  }
  items.push({
    separatorTop: true,
    href: routes.logout,
    className: 'text-danger',
    icon: StandardIcons.Logout,
    label: 'Log out',
  });
  return items;
}
